import { render, staticRenderFns } from "./LoadingPopup.vue?vue&type=template&id=a13ffc44&scoped=true&"
import script from "./LoadingPopup.vue?vue&type=script&lang=js&"
export * from "./LoadingPopup.vue?vue&type=script&lang=js&"
import style0 from "./LoadingPopup.vue?vue&type=style&index=0&id=a13ffc44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13ffc44",
  null
  
)

export default component.exports